import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MapViewComponent} from './components/map-view/map-view.component';
import {GoogleMapsModule} from '../google-maps/google-maps.module';
import {AutoSchedulerService} from '../../auto-scheduler/auto-scheduler.service';
import {DriversService} from '../../drivers/drivers.service';
import {T2LoadingService} from '../../../trip2-theme/components/t2-loading/t2-loading.service';
import {SignalRService} from '../../../core/services/signal-r.service';
import {FormsModule} from '@angular/forms';
import {PhonePipe} from './pipe/phone.pipe';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    GoogleMapsModule,
    FormsModule,
    Trip2ThemeModule
  ],
  declarations: [MapViewComponent, PhonePipe],
  exports: [MapViewComponent],
  providers: [AutoSchedulerService, DriversService, T2LoadingService, SignalRService]
})
export class MapRouteModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/map-route/map-route.module.ts